import {
	ADMINISTRATION_CHANNELING_PROFILES,
	ADMINISTRATION_RULES_PROFILES,
	ADMINISTRATION_USER_MANAGEMENT_PROFILES,
	AuthorityUsersPermissions,
	CLAIMS_ADMIN_PROFILES,
	CLAIMS_COMPLAINT_PROFILES,
	CLAIMS_OLSA_PROFILES,
	CLAIMS_PRACTICE_CAR_PROFILES,
	CLAIMS_PRACTICE_PROFILES,
	CLAIMS_REPAIR_PROFILES,
	CLAIMS_SUPERVISOR_PROFILES,
	CLAIMS_THEFT_PROFILES,
	CONTRACT_CLOSING_ALD_PROFILES,
	CONTRACT_CLOSING_DK_BO_PROFILES,
	CONTRACT_CLOSING_DKC_PROFILES,
	CONTRACT_CLOSING_DKO_PROFILES,
	CONTRACT_CLOSING_SPO_PROFILES,
	CROSS_PERMISSION_NOTIFICATION_READER,
	DELIVERY_ASR_PROFILES,
	DELIVERY_PROFILES,
	FLOTTA_POOL_PROFILES,
	INVOICING_PROFILES,
	PROFILE_LOGISTIC_ADMIN_KEY,
	PROFILE_LOGISTIC_ASR_KEY,
	PROFILE_LOGISTIC_CENTER_SUPER_USER_KEY,
	PROFILE_LOGISTIC_FLOTTA_POOL_TRANSFER_KEY,
	PROFILE_LOGISTIC_CONSULTATION_KEY,
	PROFILE_LOGISTIC_TEAM_MEMBER_KEY,
	PROFILE_TYRE_CUSTOMER_SERVICE_KEY,
	PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY,
	PROFILE_TYRES_ADMIN_KEY,
	PROFILE_TYRES_ASSISTANCE_CENTER_KEY,
	PROFILE_TYRES_CENTER_SUPER_USER,
	SuperUserPermissions,
	USER_CHANGE_ADMIN_PROFILES,
	USER_CHANGE_SP_PROFILES,
	BookingsPermissions, CLAIMS_CUSTOM_ADMIN_PROFILES, BOOKINGS_RELIEF_PROFILES, BOOKINGS_PRELEASE_PROFILES,
	MOBILITY_PROFILES,
	AUTHORITY_PROFILES,
	AUTHORITY_MOBILITY_BACKOFFICE_USER,
	PROFILE_CLAIMS_MYALD_KEY,
	AUTHORITY_DEALER_USER,
	AUTHORITY_DEALER_PROFILES,
	PROFILES_CARGOS,
	AUTHORITY_CENTER_SUPER_USER,
} from '../../permissions-variables';
import {CommodityModel, CommodityTypeId} from '@shared/models/commodity.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {ItemMenu} from '@shared/models/item-menu.model';
import {UserUtilitiesModel} from '@shared/utilities/user-utilities.model';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {BookingsProfileKey} from 'app/bookings/models/enums.models';
import {FIND_CENTERS_DASHBOARD, ROOT_AUTHORITY, ROOT_CONTRACT_CLOSING, ROOT_DELIVERY, ROOT_FLOTTA_POOL, ROOT_INVOICING, ROOT_LOGISTICS, ROOT_NOTIFICATION_CENTER, ROOT_TYRES, ROOT_USER_CHANGE} from '../../app-routing-roots';
import { Module, ModuleService } from '@shared/service/module.service';
import { logger } from '@shared/utilities/logger.model';
import { EPprofileType } from './module-nemo.model';

// const MOCK_USER = require('./user-permission.mock.json');

export class UserPermissionsModel {
	profiles: ProfilePermissionModel[];
	cross_permissions: CrossPermissionModel[];
	all_profile: ProfilePermissionModel[] = [];
	// c'è un duplicato in permission.service.ts, currentProfileKey andrebbe eliminata
	// Profilo Corrente
	private currentProfile: ProfilePermissionModel;
	static counter: number = 0;

	constructor(model?: any) {
		
		this.profiles = [];
		this.cross_permissions = [];
		if (!Utilities.isVoid(model)) {

			// bisogna scartare i profili fake
			// il modulo booking così non esiste più
			const filterFakeProfileFn = (x) => ![Module.BOOKINGS].includes(x.module.key);

			this.all_profile = 
				model.profiles
				.filter(filterFakeProfileFn)
				.map(x => new ProfilePermissionModel(x)).map(x => x);

			// Profili current per ogni modulo / Mapping modulo-profili 1:1, come prima
			this.profiles = this.all_profile.filter(x => x.current);
			
			this.initCurrentProfile(this.all_profile);
			
			for (const cross_permission of model.cross_permissions) {
				this.cross_permissions.push(new CrossPermissionModel(cross_permission));
			}
		}
	}
	
	/**
	 * Sceglie il profilo corrente in base ad alcune logiche
	 * in base a $last_profile_selected e a $current
	 * 
	 * @param   {ProfilePermissionModel} profileList
	 * @returns {ProfilePermissionModel[]}
	 */
	getNewCurrentProfile(profileList: ProfilePermissionModel[]): ProfilePermissionModel {
		
		let initProfile: ProfilePermissionModel;
		
		// 1) questo è il caso d'uso classico
		// trova l'ultimo profilo utilizzato
		initProfile = profileList.find(x => x.last_profile_selected === true);

		// 2) se c'è un'inconsistenza di dati si prende il primo profilo a current
		// sperando che sia anche ADMIN
		if (!initProfile) {
			initProfile = profileList.find(x => x.current === true);

			// serve per forza l'ADMIN - ordini dall'alto
			if (initProfile.type !== EPprofileType.ADMIN) {
				const adminProfile = profileList.find(x => x.type === EPprofileType.ADMIN);

				// controllo se trova il profilo admin
				// il modulo potrebbe avere solo profili CENTRO
				if (adminProfile) {
					initProfile = adminProfile
				}
			}
			return new ProfilePermissionModel(initProfile);
		}
		
		// -----------------------------------------------------------------------
		// nelle seguenti IF non dovrebbe mai entrare
		// ogni modulo deve avere il profilo current, per definizione

		// 4) forzare la ricerca al primo ADMIN
		// direttive dall'alto (Arcangelo)
		if (!initProfile) {
			initProfile = profileList.find(x => x.type === EPprofileType.ADMIN);
			return new ProfilePermissionModel(initProfile);
		}
		
		// 5) se non trova un profilo va in loop
		if (!initProfile) {
			initProfile = profileList[0];
			initProfile.current = true;
		}

		return new ProfilePermissionModel(initProfile);
	}
	
	initCurrentProfile(profiles: ProfilePermissionModel[]): void {

		try {
			// Trova il modulo in base all'URL, e poi il profilo associato
			// per user-change da BE arriva una key diversa da quella mappata su FE, bisogna sovrascrivere la variabile per evitare un loop infinito se si accede diretamente da link 
			const module = ModuleService.getCurrentModule() === Module.USER_CHANGE ? Module.USER_CHANGE_FROM_BE :  ModuleService.getCurrentModule() ;				

			// 1) SE È NELLA HOME, O NELLA PAGINA PROFILO, O SE NON È UN MODULO VALIDO
			if (!module || module === Module.PROFILE) {
				this.currentProfile = this.getNewCurrentProfile(profiles);
				
				// TODO
				// inserire la update di Arcangelo (per sicurezza) - this.all_profile
				// non è detto che il profilo corrente sia lo stesso mandato da BE
				return;
			}

			// 2) GESTIRE LA LOGICA IN BASE AL REDIRECT_URI
			const redirectURL = localStorage.getItem('redirect_uri');
			if (redirectURL) {
			
				// prendere il modulo dall'URL
				// **ho dovuto convertire in stringa perché c'è incompatibilità tra Module e NemoModuleKeys 
				const moduleByURL: string = ModuleService.getModuleByURL(redirectURL) as string;
				
				// prendere un profilo in base al modulo (possibilmente ADMIN)
				const profileListByModule = this.getProfileListByModule(moduleByURL as NemoModuleKeys);
				this.currentProfile = this.getNewCurrentProfile(profileListByModule);
				
				// o proprio Relief Mobility
				// const newProfile = this.userPermission.getProfileByKey(NEMO_MOBILITY_BOOKINGS_RELIEF_CA_PILOT)
				return;
			}

			// 3) SETTIAMO IL PROFILO IN BASE AL MODULO DELL'URL
			// Nel caso di mobility, dove c'è un redirect verso NEMO
			// potrebbe non essere visibile la pagina richiesta
			// se last_profiie_selected è di un altro modulo X
			// il comportamento attuale è che fa il redirect nella home del modulo X, o 404
						
			const profileList: ProfilePermissionModel[] = profiles.filter(x => x.module.key === module);

			if (profileList && profileList.length > 0 && profileList[0]) {
				this.currentProfile = this.getNewCurrentProfile(profileList);
				
				// TODO
				// inserire la update di Arcangelo - this.all_profile
				// per il momento non gli piace, ci dobbiamo ragionare
				return;
			}

			// TODO - gestire il caso 

			// if (profileList.length === 1) {
			// 	if(profileList[0].key){
			// 	this.loaderService.display(true);
			// 		this.permissionService.updateCurrentProfile(this.userV3Service.getCurrentUser().id, profileList[0].key).subscribe(res => {
			// 			profile.setCurrentProfile(profileList[0].key);
			// 			this.loaderService.display(false);
			// 		});
			// 	}
			// 	return;
			// }

			// TODO - gestione con la dialog
			// può avere la necessità di cambiare profilo anche se non si cambia modulo
			// if (profileList.length > 1) {
			// }


			// 3) SE NON È STATO TROVATO UN PROFILO IN BASE AL MODULO DELL'URL
			// viene settato il profilo in base al parametro last_profile_selected

			// il profilo corrente in base al modulo - potrebbe essere undefined
			// const currentProfile = profiles.find(x => x.module.key === module && x.current === true);
			const currentProfile = profiles.find(x => x.last_profile_selected === true);

			// const profile = currentProfile ? new ProfilePermissionModel(currentProfile) : null;
			const profile = new ProfilePermissionModel(currentProfile);

			// se il modulo non è associato a nessun profilo - URL sbagliato
			// vai in 404
			this.currentProfile = profile ? profile : null;

		} catch (e) {
			console.error(e);
		}
	}
	
	getProfileListByModule(module: NemoModuleKeys): ProfilePermissionModel[] {
		if (!module || !this.all_profile) {
			return [];
		}
		return this.all_profile.filter(x => x.module.key === module);
	}

	setProfilePermission(profileKey: string): void {

		if (!profileKey) {
			return;
		}

		const newProfile = this.all_profile.find(x => x.key === profileKey);

		if (!newProfile) {
			return;
		}

		// const currentProfile = this.getCurrentProfile();
		
		// // aggiornamento situazione profili
		// this.all_profile = this.all_profile.map(x => {

		// 	// da rivedere
		// 	// il caso se i 2 profili siano nello steso modulo
		// 	// il caso se i 2 profili siano in 2 moduli diversi

		// 	if (x.key === currentProfile.key) {
		// 		// x.current = 
		// 		x.last_profile_selected = false;
		// 	}

		// 	if (x.key === newProfile.key) {
		// 		x.current = x.last_profile_selected = true;
		// 	}

		// 	return x;
		// });

		// // aggiornamento profili correnti
		// this.profiles = this.all_profile.filter(x => !!x.current);

		// TODO
		// inserire la update di Arcangelo - this.all_profile
		// per il momento non gli piace, ci dobbiamo ragionare

		// Rimuovere il profilo associato al modulo (del profilo in input)
		// this.profiles = this.profiles.filter(x => x.module.key !== newProfile.module.key).map(x => x);
		
		this.profiles = [
			// Rimuovere il profilo associato al modulo (del profilo in input)
			...this.profiles.filter(x => x.module.key !== newProfile.module.key).map(x => x), 
			newProfile
		];
	}

	isAldOperator(module: NemoModuleKeys): boolean {
		if (this.currentProfile) {
			//const profile: ProfilePermissionModel = this.profiles.find(p => p.last_profile_selected && p.module && p.module.key === module);
			return this.currentProfile.module && this.currentProfile.module.key === module && this.currentProfile.type === 'ADMIN';
		}
		return false;
	}

	isDealerOperator(module: NemoModuleKeys): boolean {
		if (this.currentProfile) {
			//const profile: ProfilePermissionModel = this.profiles.find(p =>p.last_profile_selected && p.module && p.module.key === module);
			return this.currentProfile.module && this.currentProfile.module.key === module && this.currentProfile.type === 'DEALER';
		}
		return false;
	}

	isCenterOperator(module: NemoModuleKeys): boolean {
		if (this.currentProfile) {
			const profile: ProfilePermissionModel = this.currentProfile;
			if (profile && profile.module && profile.module.key==module) {
				if (profile.type === 'CENTER') {
					return true;
				}
				if (profile.type === 'CENTER_SUPER_USER') {
					return true;
				}
				if (profile.type === 'DEALER') {
					return true;
				}
			}
		}
		return false;
	}

	isAssistanceCenterOperator(): boolean {
		if (this.currentProfile) {
			const profile = this.currentProfile;
			if (profile && (profile.key === BookingsProfileKey.module_prelease_assistance_center ||
				profile.key===BookingsProfileKey.module_relief_assistance_center || 
				profile.key===BookingsProfileKey.module_relief_assistance_center_pilot
			)) {
					return true;
			}
		}
		return false;
	}

	isCenterSuperUserOperator(module: NemoModuleKeys): boolean {
		if (this.currentProfile) {
			const profile : ProfilePermissionModel = this.currentProfile; 			
			if (profile && profile.module && profile.module.key === module && profile.type === 'CENTER_SUPER_USER' ) {
					return true;
			}
		}
		return false;
	}

	isSuperUserByLocationPath(module: string): boolean {
		switch (module) {
			case ROOT_AUTHORITY:
				return this.isCenterSuperUserOperator(NemoModuleKeys.AUTHORITY);
			case ROOT_CONTRACT_CLOSING:
				return this.isCenterSuperUserOperator(NemoModuleKeys.CONTRACT_CLOSING_);
			case ROOT_INVOICING:
				return this.isCenterSuperUserOperator(NemoModuleKeys.INVOICING);
			case ROOT_USER_CHANGE:
				return this.isCenterSuperUserOperator(NemoModuleKeys.USER_CHNAGE_);
			case ROOT_TYRES:
				return this.isCenterSuperUserOperator(NemoModuleKeys.TYRES);
			case ROOT_LOGISTICS:
				return this.isCenterSuperUserOperator(NemoModuleKeys.LOGISTICS);
			case ROOT_FLOTTA_POOL:
				return this.isCenterSuperUserOperator(NemoModuleKeys.FLOTTA_POOL);
			case ROOT_DELIVERY:
				return this.isCenterSuperUserOperator(NemoModuleKeys.DELIVERY);
			case ROOT_NOTIFICATION_CENTER:
				return this.profiles.some(profile => profile.type === 'CENTER_SUPER_USER');
			default:
				return false;
		}
	}

	hasPermissionForSearch(): boolean {
		return this.hasProfile(DELIVERY_PROFILES);
	}

	getCurrentProfileList(): ProfilePermissionModel[] {
		return this.profiles;
	}

	getProfileList(): ProfilePermissionModel[] {
		return this.all_profile;
	}

	getProfileModules(): Module[] {
		return this.profiles.map(x => x.module.key) as Module[];
	}

	getModuleByProfileKey(): Module {

		if (!this.currentProfile) {
			return null;
		}
		
		const profile = this.profiles.find(x => x.key === this.currentProfile.key);

		if (!profile) {
			return null;
		}
		
		return profile.module.key as Module;
	}

	getCurrentProfile(): ProfilePermissionModel {
		return this.currentProfile;
	}

	// viene chiamata in un secondo momento, più semplice della initCurrentProfile
	setCurrentProfile(profile_key: string): void {
		const profile = this.profiles && this.profiles.find(p => p.key == profile_key);
		
		if (profile) {
			this.currentProfile = profile;
		}
	}

	hasCurrentProfile(profile_key: string | string[]): boolean {
		
		try {

			// se c'è il redirect da MyALD
			// il profilo corrente dev'essere forzato
			// altrimenti non lo trova e va in loop
			const current = (profile_key === PROFILE_CLAIMS_MYALD_KEY) ? PROFILE_CLAIMS_MYALD_KEY : this.getCurrentProfile().key;

			if (!current) {
				return false;
			}
			
			const list: string[] = Array.isArray(profile_key) ? profile_key : [profile_key];
			return list.includes(this.getCurrentProfile().key);

		} catch (e) {
			console.error(e);
		}
	}
	
	hasProfile(profileKeys: string[]): boolean {
		return this.hasCurrentProfile(profileKeys);
	}

	/**
	 * La funzione controlla se l'utente ha almeno un profilo di tipo ADMIN
	 * 
	 * al momento viene usata nella pagina profilo (pagina neutra)
	 * per mostrare i template
	 * 
	 * @returns {booledan}
	 **/
	hasSomeAdminProfile(): boolean {
		return this.profiles.some(x => x.type === EProfileType.ADMIN);
	}

	hasCrossPermission(crossPermissionKey: string): boolean {
		if (!Utilities.isVoid(crossPermissionKey)) {
			return !Utilities.isVoid(
				this.getCrossPermission(crossPermissionKey)
			);
		}
		return false;
	}

	getCrossPermission(crossPermissions: string): CrossPermissionModel {
		if (!Utilities.isVoid(crossPermissions) && crossPermissions.length > 0) {
			for (const crossPermission of this.cross_permissions) {
				if (crossPermission.key === crossPermissions) {
					return crossPermission;
				}
			}
		}
		return null;
	}

	getProfileFromModule(module: string): ProfilePermissionModel {
		for (const profile of this.profiles) {
			if (!Utilities.isVoid(profile) && !Utilities.isVoid(profile.module)
				&& profile.module.key === module) {
				return profile;
			}
		}
		return null;
	}


	getProfileByKey(profileKey: string): ProfilePermissionModel {
		for (const profile of this.profiles) {
			if (!Utilities.isVoid(profile) && !Utilities.isVoid(profile.key)
				&& profile.key === profileKey) {
				return profile;
			}
		}
		return null;
	}

	getModulesItemsMenu(): Function {

		const ctx = this;

		return function(pivot: boolean): ItemMenu[] {

			const hasProfile = function(profileKeys: string[]): boolean {
				
				const obj = pivot ? ctx.profiles : ctx.all_profile;
				return obj.some(p => profileKeys.includes(p.key));
			};

			const getProfileKey = function(profileKeys: string): string {
				
				const obj = pivot ? ctx.profiles : ctx.all_profile;
				return obj.find(p => profileKeys.includes(p.key)).key;
			};
			
			const hasSomePermission = function(permissions: string[]): boolean {
				const obj = pivot ? ctx.profiles : ctx.all_profile;
				return obj && obj.some(p => permissions && permissions.some(pe => p.permissions && p.permissions.includes(pe)));
			};
			
			const isCenterSuperUserOperator = function(module: NemoModuleKeys): boolean {
				const obj = pivot ? ctx.profiles : ctx.all_profile;
				if (obj) {
					const profile: ProfilePermissionModel = obj.find(p => p.module && p.module.key === module);
					if (profile) {
						if (profile.type === 'CENTER_SUPER_USER') {
							return true;
						}
					}
				}
				return false;
			};
			
			const getProfileByKey = (profileKey: string): ProfilePermissionModel => {
				const obj = pivot ? ctx.profiles : ctx.all_profile;
				for (const profile of obj) {
					if (!Utilities.isVoid(profile) && !Utilities.isVoid(profile.key)
						&& profile.key === profileKey) {
						return profile;
					}
				}
				return null;
			};

			const isCenterSuperUserOperatorByProfileType = function(type:string): boolean {
				if (type === 'CENTER_SUPER_USER') {
					return true;
				}
				return false;
			};

			const isProfileType = function(types: string[], type: string): boolean {
				if(types.includes(type)){
					return true;
				}
				return false;
			};
		
			// -----------------------

			const result: ItemMenu[] = [];

			ctx.all_profile.forEach(profile => {

				if (PROFILES_CARGOS.includes(profile.key)) {
					result.push(UserUtilitiesModel.getCargosItemMenu(UserV3Model.CARGOS_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (DELIVERY_PROFILES.includes(profile.key)) {
					let cFunction = isCenterSuperUserOperatorByProfileType(profile.type) ? UserUtilitiesModel.getSUDeliveryItemMenu : UserUtilitiesModel.getDeliveryItemMenu;
					result.push( cFunction(UserV3Model.DELIVERY_ITEM_MENU_ID, profile.key, profile.name) );
						
				}

				if (DELIVERY_ASR_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getDeliveryASRItemMenu(UserV3Model.DELIVERY_ASR_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CONTRACT_CLOSING_SPO_PROFILES.includes(profile.key)) { 
					let cFunction = isCenterSuperUserOperatorByProfileType(profile.type) ? UserUtilitiesModel.getCCSPOSUItemMenu : UserUtilitiesModel.getCCSPOItemMenu;
					result.push(cFunction(UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID, profile.key, profile.name));

				}

				if (CONTRACT_CLOSING_ALD_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getCCALDItemMenu(UserV3Model.CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CONTRACT_CLOSING_DKO_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getCCDKOItemMenu(UserV3Model.CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CONTRACT_CLOSING_DKC_PROFILES.includes(profile.key)) { 
					result.push(UserUtilitiesModel.getCCDKCItemMenu(UserV3Model.CONTRACT_CLOSING_DK_C_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CONTRACT_CLOSING_DK_BO_PROFILES.includes(profile.key)) { 
					result.push(UserUtilitiesModel.getCCBOItemMenu(UserV3Model.CONTRACT_CLOSING_DK_BO_OP_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CLAIMS_ADMIN_PROFILES.includes(profile.key)) { 
					result.push(UserUtilitiesModel.getClaimsAdminItemMenu(UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CLAIMS_CUSTOM_ADMIN_PROFILES.includes(profile.key)) { 
					result.push(UserUtilitiesModel.getClaimsAdminItemMenu(UserV3Model.CLAIMS_CUSTOM_ADMIN_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CLAIMS_THEFT_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getClaimsTheftItemMenu(UserV3Model.CLAIMS_THEFT_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CLAIMS_SUPERVISOR_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getClaimsSupervisorItemMenu(UserV3Model.CLAIMS_SUPERVISOR_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CLAIMS_OLSA_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getClaimsOlsaItemMenu(UserV3Model.CLAIMS_OLSA_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CLAIMS_REPAIR_PROFILES.includes(profile.key)) { 
					result.push(UserUtilitiesModel.getClaimsRepairItemMenu(UserV3Model.CLAIMS_REPAIR_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CLAIMS_PRACTICE_CAR_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getClaimsPracticeCarItemMenu(UserV3Model.CLAIMS_PRACTICE_CAR_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CLAIMS_PRACTICE_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getClaimsPracticesItemMenu(UserV3Model.CLAIMS_PRACTICES_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (CLAIMS_COMPLAINT_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getClaimsComplaintItemMenu(UserV3Model.CLAIMS_COMPLAINT_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (profile.module.key === Module.AUTHORITY) {
					
					if (profile.key === AUTHORITY_CENTER_SUPER_USER) {
						result.push(UserUtilitiesModel.getAuthoritySUItemMenu(UserV3Model.AUTHORITY_ITEM_MENU_ID, profile.key, profile.name));
						return;
					}
					if (AUTHORITY_DEALER_PROFILES.includes(profile.key)) {
						result.push(UserUtilitiesModel.getAuthorityDealerItemMenu(UserV3Model.AUTHORITY_ITEM_MENU_ID, profile.key, profile.name));
						return;
					}
					if (AUTHORITY_PROFILES.includes(profile.key)) {
						result.push(UserUtilitiesModel.getAuthorityItemMenu(UserV3Model.AUTHORITY_ITEM_MENU_ID, profile.key, profile.name));
						return;
					}
				}

				// if (AUTHORITY_PROFILES.includes(profile.key) && !AUTHORITY_DEALER_PROFILES.includes(profile.key)) {
				// 	result.push(UserUtilitiesModel.getAuthorityItemMenu(UserV3Model.AUTHORITY_ITEM_MENU_ID, profile.key, profile.name));
				// } else if(AUTHORITY_DEALER_PROFILES.includes(profile.key)){
				// 	result.push(UserUtilitiesModel.getAuthorityDealerItemMenu(UserV3Model.AUTHORITY_ITEM_MENU_ID, profile.key, profile.name));
				// }

				// if (profile.key === AUTHORITY_CENTER_SUPER_USER) {
				// 	result.push(UserUtilitiesModel.getAuthoritySUItemMenu(UserV3Model.AUTHORITY_ITEM_MENU_ID, profile.key, profile.name));
				// } 
						
				if (MOBILITY_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getMobilityItemMenu(UserV3Model.MOBILITY_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (INVOICING_PROFILES.includes(profile.key)) {
					let cFunction = isCenterSuperUserOperatorByProfileType(profile.type) ? UserUtilitiesModel.getInvoicingSUItemMenu : UserUtilitiesModel.getInvoicingItemMenu; 
					result.push(cFunction(UserV3Model.INVOICING_ITEM_MENU_ID, profile.key, profile.name));
				}

				if (USER_CHANGE_ADMIN_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getUCALDItemMenu(UserV3Model.USER_CHANGE_ALD_MENU_ID, profile.key, profile.name));
				}

				if (USER_CHANGE_SP_PROFILES.includes(profile.key)) {
					let cFunction = isCenterSuperUserOperatorByProfileType(profile.type) ? UserUtilitiesModel.getUCSPSUItemMenu : UserUtilitiesModel.getUCSPItemMenu; 
					result.push(cFunction(UserV3Model.USER_CHANGE_SP_MENU_ID, profile.key, profile.name));
				}

			  // Fix problema impossibile Administration (cambio modulo e canExit)
				// gestire meglio Administration, va diviso tra 

				// ROOT_ADMINISTRATION_RULES,
				// ROOT_ADMINISTRATION_USER_MANAGEMENT,
				// ROOT_ADMINISTRATION,
				// ROOT_ADMINISTRATION_CHANNELING,
	
				// al momento ritorna sempre lo stesso oggetto che ha l'URL verso Administrator e basta
				// (però perché esce solo adesso?)
				
				if (ADMINISTRATION_USER_MANAGEMENT_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getAdministrationItemMenu(profile, 'ADMINISTRATION_USER_MANAGEMENT'));
				}
				if (ADMINISTRATION_RULES_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getAdministrationItemMenu(profile, 'ADMINISTRATION_RULES'));
				}
				if (ADMINISTRATION_CHANNELING_PROFILES.includes(profile.key)) {
					result.push(UserUtilitiesModel.getAdministrationItemMenu(profile, 'ADMINISTRATION_CHANNELING'));
				}



				if ([PROFILE_TYRES_ASSISTANCE_CENTER_KEY, PROFILE_TYRES_CENTER_SUPER_USER].includes(profile.key)) {
					let cFunction = isCenterSuperUserOperatorByProfileType(profile.type) ? UserUtilitiesModel.getTyresSUItemMenuOpc : UserUtilitiesModel.getTyresItemMenuOpc; 
					result.push(cFunction(UserV3Model.TYRES_ITEM_OPC_MENU_ID, profile.key, profile.name));
				}

				if ([PROFILE_TYRES_ADMIN_KEY].includes(profile.key)) {
					result.push(UserUtilitiesModel.getTyresItemMenuOpa(UserV3Model.TYRES_ITEM_OPA_MENU_ID, profile.key, profile.name));
				}

				if ([PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY].includes(profile.key)) {
					result.push(UserUtilitiesModel.getTyresItemMenuOpf(UserV3Model.TYRES_ITEM_OPF_MENU_ID, profile.key, profile.name));
				}

				if ([PROFILE_TYRE_CUSTOMER_SERVICE_KEY].includes(profile.key)) {
					result.push(UserUtilitiesModel.getTyresItemMenuOps(UserV3Model.TYRES_ITEM_OPS_MENU_ID, profile.key, profile.name));
				}

				if ([PROFILE_LOGISTIC_TEAM_MEMBER_KEY, PROFILE_LOGISTIC_FLOTTA_POOL_TRANSFER_KEY].includes(profile.key)) {
					result.push(UserUtilitiesModel.getLogisticsItemMenuOpl(UserV3Model.LOGISTICS_ITEM_OPL_MENU_ID, profile.key, profile.name));
				}

				if ([PROFILE_LOGISTIC_ADMIN_KEY].includes(profile.key)) {
					result.push(UserUtilitiesModel.getLogisticsItemMenuOpad(UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID, profile.key, profile.name));
				}

				if ([PROFILE_LOGISTIC_ASR_KEY, PROFILE_LOGISTIC_CENTER_SUPER_USER_KEY].includes(profile.key)) {
					let cFunction = isCenterSuperUserOperatorByProfileType(profile.type) ? UserUtilitiesModel.getLogisticsItemMenuSU : UserUtilitiesModel.getLogisticsItemMenuOpas; 
					result.push(cFunction(UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID, profile.key, profile.name));
				}

				if ([PROFILE_LOGISTIC_CONSULTATION_KEY].includes(profile.key)) {
					result.push(UserUtilitiesModel.getLogisticsItemMenuOpc(UserV3Model.LOGISTICS_ITEM_OPC_MENU_ID, profile.key, profile.name));
				}
	
				if (FLOTTA_POOL_PROFILES.includes(profile.key)) {
					if (profile.key ==='flotta-pool_assistance_center') {
						result.push(UserUtilitiesModel.getFlottaPoolItemMenuOperator(UserV3Model.FLOTTA_POOL_MENU_ID, profile.key, profile.name));
					} else if (isCenterSuperUserOperatorByProfileType(profile.type)) {
						result.push(UserUtilitiesModel.getFlottaPoolSUItemMenu(UserV3Model.FLOTTA_POOL_MENU_ID, profile.key, profile.name));
					} else {
						result.push(UserUtilitiesModel.getFlottaPoolItemMenu(UserV3Model.FLOTTA_POOL_MENU_ID, profile.key, profile.name));
					}
				}

				if (profile.permissions.includes(BookingsPermissions.bookings_relief_can_retrieve_bookings_list)) {
					if (profile.permissions.includes(BookingsPermissions.bookings_relief_can_view_dashboard)) {
						result.push(UserUtilitiesModel.getBookingItemMenuReliefDashBoard(UserV3Model.BOOKINGS_RELIEF_MENU_ID, profile.key, profile.name));
					} else {
						result.push(UserUtilitiesModel.getBookingItemMenuRelief(UserV3Model.BOOKINGS_RELIEF_MENU_ID, profile.key, profile.name));
					}
				}

				if (NemoModuleKeys.BOOKINGS.includes(profile.key)) {
					result.push(UserUtilitiesModel.getBookingSUItemMenuRelief(UserV3Model.BOOKINGS_RELIEF_MENU_ID, profile.key, profile.name));
				}
	

				if (profile.permissions.includes(BookingsPermissions.bookings_prelease_can_retrieve_bookings_list)) {
					if (profile.permissions.includes(BookingsPermissions.bookings_prelease_can_view_dashboard)) {
						result.push(UserUtilitiesModel.getBookingItemMenuPreleaseDashBoard(UserV3Model.BOOKINGS_PRELEASE_MENU_ID, profile.key, profile.name));
					} else {
						result.push(UserUtilitiesModel.getBookingItemMenuPrelease(UserV3Model.BOOKINGS_PRELEASE_MENU_ID, profile.key, profile.name));
					}
				}

			//	if (profile.permissions.includes(BookingsPermissions.bookings_prelease_can_retrieve_bookings_list)) { 
			//		result.push(UserUtilitiesModel.getBookingItemMenuPrelease(UserV3Model.BOOKINGS_PRELEASE_MENU_ID, hasSomePermission([BookingsPermissions.bookings_prelease_can_view_dashboard]), profile.key, profile.name));
			//	}


			});

			if(pivot){ //Ritorna solo gli item menu correnti
				let curretItemMenu: ItemMenu[] = [];
				ctx.all_profile.forEach(profile => {
					
					if (profile.current){
						curretItemMenu.push(result.find(item => item.profile_key === profile.key));
						// return;
					}

					// mobility porkaround  per la current a true
					// if (MOBILITY_MYMOBILITY_PROFILE_USER.includes(profile.key)) {
					// 	curretItemMenu.push(result.find(x => x.profile_key === MOBILITY_MYMOBILITY_PROFILE_USER[0]));
					// }
				});
				return curretItemMenu;
			}			
			return result; //Ritorna tutti gli item menu
		}
	};

	getNotificationCenterItemMenu(): ItemMenu {
		if (this.getCrossPermission(CROSS_PERMISSION_NOTIFICATION_READER)) {
			const itemMenu: ItemMenu = UserUtilitiesModel.getNotificationCenterItemMenu(UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID);
			if (this.isSuperUserByLocationPath(ROOT_NOTIFICATION_CENTER)) {
				itemMenu.routerLink = `/${ROOT_NOTIFICATION_CENTER}/${FIND_CENTERS_DASHBOARD}`;
			}
			return itemMenu;
		}
	}

	getStaticItemsMenu(): ItemMenu[] {
		const result: ItemMenu[] = [];
		result.push(UserUtilitiesModel.getProfileItemMenu(UserV3Model.PROFILE_ITEM_MENU_ID));
		return result;
	}

	getCommodities(itemMenuID: string): CommodityModel[] {
		const tempRes = new Set<CommodityModel>();
		for (const profile of this.profiles) {
			if (this.getProfilesNameForItemMenu(itemMenuID).includes(profile.key)) {
				for (const commodity of profile.commodities) {
					tempRes.add(commodity);
				}
			}
		}
		return Array.from(tempRes);
	}

	/**
	 * Salva le commodities del profilo corrente
	 * 
	 * Viene chiamata quando si cambia profilo
	 * dentro select-commodities.service.ts
	 * 
	 * @param {CommodityModel[]} commodityList
	 */ 
	setCommodities(commodityList: CommodityModel[]): void {
		this.currentProfile.commodities = commodityList;
	}

	setCommoditiesForSuperUser(moduleKey: string, commodities: CommodityModel[]): void {
		
		if (
			Utilities.isEmpty(this.profiles) || 
			Utilities.isEmpty(moduleKey) || 
			Utilities.isEmpty(commodities)
		) {
			return;
		}
				
		const profile = this.profiles.find(p => p.module && p.module.key === moduleKey);

		if (Utilities.isEmpty(profile)) {
			return;
		}

		profile.commodities = commodities;
	}

	getProfileCommodities(profileKey: string): CommodityModel[] {
		const profile = this.getProfileByKey(profileKey);
		if (!Utilities.isVoid(profile)) {
			return profile.commodities;
		}
		return [];
	}

	getModuleCommodities(moduleKey: NemoModuleKeys): CommodityModel[] {
		if (this.profiles) {
			// TODO MULTIPROFILO
			// gestire multiprofilo, l'unico criterio è 
			const profile: ProfilePermissionModel = this.profiles.find(p => p.module && p.module.key === moduleKey);
			return profile ? profile.commodities : [];
		}
		return [];
	}

	hasPermissions(permissions: string[] | string): boolean {

		if (!this.currentProfile) {
			return false;
		}

		// Controlla i permessi soltanto del profilo corrente
		if (this.currentProfile.hasPermissions(SuperUserPermissions.super_user_can_read_all)) {
			return true;
		}
		if (this.currentProfile.hasPermissions(permissions)) {
			return true;
		}
		return false;
	}

	hasSomePermission(permissions: string[]): boolean {
		return this.profiles && this.profiles.some(p => p.key == this.currentProfile.key && p.current && permissions && permissions.some(pe => p.permissions && p.permissions.includes(pe)));
	}

	private getProfilesNameForItemMenu(itemMenuID: string): string[] {

		switch (itemMenuID) {
			case UserV3Model.DELIVERY_ITEM_MENU_ID:
				return DELIVERY_PROFILES;
			case UserV3Model.DELIVERY_ASR_ITEM_MENU_ID:
				return DELIVERY_ASR_PROFILES;
			case UserV3Model.CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID:
				return CONTRACT_CLOSING_ALD_PROFILES;
			case UserV3Model.CONTRACT_CLOSING_DK_C_ITEM_MENU_ID:
				return CONTRACT_CLOSING_DKC_PROFILES;
			case UserV3Model.CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID:
				return CONTRACT_CLOSING_DKO_PROFILES;
			case UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID:
				return CONTRACT_CLOSING_SPO_PROFILES;
			case UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID:
				return CLAIMS_ADMIN_PROFILES;
			case UserV3Model.CLAIMS_PRACTICE_CAR_ITEM_MENU_ID:
				return CLAIMS_PRACTICE_CAR_PROFILES;
			case UserV3Model.CLAIMS_SUPERVISOR_ITEM_MENU_ID:
				return CLAIMS_SUPERVISOR_PROFILES;
			case UserV3Model.INVOICING_ITEM_MENU_ID:
				return INVOICING_PROFILES;
			case UserV3Model.TYRES_ITEM_OPC_MENU_ID:
				return [PROFILE_TYRES_ASSISTANCE_CENTER_KEY, PROFILE_TYRES_CENTER_SUPER_USER];
			case UserV3Model.TYRES_ITEM_OPA_MENU_ID:
				return [PROFILE_TYRES_ADMIN_KEY];
			case UserV3Model.TYRES_ITEM_OPF_MENU_ID:
				return [PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY];
			case UserV3Model.TYRES_ITEM_OPS_MENU_ID:
				return [PROFILE_TYRE_CUSTOMER_SERVICE_KEY];
			case UserV3Model.USER_CHANGE_ALD_MENU_ID:
				return USER_CHANGE_ADMIN_PROFILES;
			case UserV3Model.USER_CHANGE_SP_MENU_ID:
				return USER_CHANGE_SP_PROFILES;
			case UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID:
				return [PROFILE_LOGISTIC_ASR_KEY, PROFILE_LOGISTIC_CENTER_SUPER_USER_KEY, PROFILE_LOGISTIC_FLOTTA_POOL_TRANSFER_KEY];
			case UserV3Model.FLOTTA_POOL_MENU_ID:
				return FLOTTA_POOL_PROFILES;
			case UserV3Model.BOOKINGS_RELIEF_MENU_ID:
				return BOOKINGS_RELIEF_PROFILES;
			case UserV3Model.BOOKINGS_PRELEASE_MENU_ID:
				return BOOKINGS_PRELEASE_PROFILES;
		}
		return [];
	}

	// Metodi di controllo riscritti dopo multiprofilo
	// andrebbero messi in un altro file
	// possibile dentro all'entità Profile

	// TODO
	// Fare un metodo globale per evitare il codice ridondante

	checkProfileType(profileTypeList: EProfileType[]): boolean {

		const profile = this.getCurrentProfile();
		if (profile && profileTypeList.includes(profile.type as EProfileType)) {
			return true;
		}
		return false;
	}

	// Non c'è più bisogno di passare il modulo
	// guardano direttamente il profilo corrente
	// così evitiamo di specificare se Authority o Mobility

	isAldOperator2(): boolean {
		return this.checkProfileType([EProfileType.ADMIN]);
	}

	isDealerOperator2(): boolean {
		return this.checkProfileType([EProfileType.DEALER]);
	}

	isCenterOperator2(): boolean {
		return this.checkProfileType([EProfileType.CENTER, EProfileType.CENTER_SUPER_USER, EProfileType.DEALER]);
	}	

	// TODO
	// sembra essere ridondante, da capire se si può togliere
	isCenter(): boolean {
		return this.checkProfileType([EProfileType.CENTER]);
	}
	
	isCenterSuperUserOperator2(): boolean {
		return this.checkProfileType([EProfileType.CENTER_SUPER_USER]);
	}
	
	// TODO
	// da capire se ha senso l'esistenza di questa funzione
	// forse va spostata come funzione statica nell'entità BookingModel
	isAssistanceCenterOperator2(): boolean {

		const profile = this.getCurrentProfile();
		const arr = [BookingsProfileKey.module_prelease_assistance_center, BookingsProfileKey.module_relief_assistance_center_pilot, BookingsProfileKey.module_relief_assistance_center];

		if (profile && arr.includes(profile.key as BookingsProfileKey)) {
			return true;
		}
		return false;
	}
}

export class ProfilePermissionModel {
	id: string;
	name: string;
	key: string;
	type: string; 
	module: ModulePermissionModel;
	description: string;
	permissions: string[];
	is_custom: boolean;
	has_commodities: boolean;
	commodities: CommodityModel[];
	created_at: string;
	updated_at: string;
	current?: boolean;
	last_profile_selected?: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {

			this.id = model.id;
			this.name = model.name;
			this.key = model.key;
			this.type = model.type;
			this.module = new ModulePermissionModel(model.module);
			this.description = model.description;
			this.permissions = [];
			this.is_custom = !Utilities.isVoid(model.is_custom) ? model.is_custom : false;
			
			if (model.permissions) {
				for (const permission of model.permissions) {
					this.permissions.push(permission);
				}
			}
			// this.commodities = [];
			// for (const commodity of model.commodities) {
				// 	this.commodities.push(new CommodityModel(commodity));
				// }

			this.has_commodities = !Utilities.isVoid(model.has_commodities) ? model.has_commodities : false;
			this.commodities = (model.commodities && Array.isArray(model.commodities)) ? model.commodities.map(x => new CommodityModel(x)) : [];
			
			// serializzazione - dall'API dei log di User Management arriva diverso
			this.has_commodities = (this.commodities && typeof this.commodities === 'boolean') ? this.commodities : this.has_commodities;
			this.commodities = model.commodities_list ? model.commodities_list.map(x => new CommodityModel(x)) : this.commodities;
			


			if (this.commodities.length > 1) {
				this.commodities.sort((c1, c2) => {
					if (c1.name < c2.name) {
						return -1;
					}
					if (c1.name > c2.name) {
						return 1;
					}
					return 0;
				});
				
				// rappresenta "Tutti i centri", nel menù in alto a destra
				// inutile e dannosa
				// questa cosa andava gestita soltanto nell'HTML di select-center.component
				// la prima commodity viene filtrata ovunque perché non serve!

				// const allCommodities = new CommodityModel({
				// 	ald_commodity_id: CommodityModel.allCentersID
				// });

				// this.commodities.unshift(allCommodities);
			}
			this.created_at = model.created_at;
			this.updated_at = model.updated_at;
			this.current = model.current;
			this.last_profile_selected = model.last_profile_selected;
		}
	}

	setCommodities(commodities: CommodityModel[]): void {
		this.commodities = commodities;
	}

	hasPermissions(permissions: string | string[]): boolean {
		if (!Utilities.isEmpty(this.permissions) && !Utilities.isVoid(permissions) && permissions.length > 0) {
			let includes = false;
			if (typeof permissions === 'string') {
				includes = this.permissions.includes(permissions);
			} else {
				for (const permission of permissions) {
					if (this.permissions.includes(permission)) {
						return true;
					}
				}
			}
			return includes;
		}
		return true;
	}

	/**
	 * controlla se il profilo è di tipo Admin/Backoffice
	 * 
	 * @returns {boolean}
	 */
	isAdmin(): boolean {
		return this.type == EProfileType.ADMIN;
	}

	/**
	 * controlla se il profilo è di tipo Dealer
	 * 
	 * @returns {boolean}
	 */
	isDealer(): boolean {
		return this.type == EProfileType.DEALER;
	}

	/**
	 * controlla se il profilo è di tipo Center
	 * 
	 * @returns {boolean}
	 */
	isCenter(): boolean {
		return [EProfileType.CENTER, EProfileType.CENTER_SUPER_USER, EProfileType.DEALER].includes(this.type as EProfileType);
	}	

	/**
	 * controlla se il profilo è di tipo CenterSuperUser
	 * 
	 * @returns {boolean}
	 */
	isCenterSuperUser(): boolean {
		return this.type == EProfileType.CENTER_SUPER_USER;
	}
}

export class ModulePermissionModel {
	id					!: string;
	key					!: string;
	name				!: string;
	description	!: string;
	created_at	!: string;
	module_key_old?: string;

	constructor(model?: any) {

		if (Utilities.isEmpty(model)) {
			return;
		}

		this.id = model.id || model.module_id || model.id_module;
		this.module_key_old = model.key;
		this.key = this.getModuleKey(model.key);
		this.name = model.name;
		this.description = model.description;
		this.created_at = model.created_at;
	}

	// Alcuni moduli hanno diversi nomi
	// la funzione li normalizza per dare uno standard definito
	// altrimenti va in loop tutta l'applicazione
	private getModuleKey(key: string): string {
	
		switch (key) {
			
			case 'administration_user_management': 
				return Module.ADMINISTRATION_USER_MANAGEMENT;
		
			// bisogna normalizzare l'URL ROOT_USER_CHANGE in app-routing-roots.ts
			// e cambiare Module.USER_CHANGE in tutto il progetto, con Module.CHANGE_USER

			// case 'change-user': 
			// 	return Module.USER_CHANGE;

			default:
				return key;
		}
	}
}

export class CrossPermissionModel {
	key: string;
	properties: Map<string, string>;

	constructor(model?: any) {
		this.properties = new Map<string, string>();
		if (!Utilities.isVoid(model)) {
			this.key = model.key;
			for (const property of model.properties) {
				this.properties.set(property.name, property.value);
			}
		}
	}
}

// questo enum deve stare qua!!
// andava messo in un model o service relativi alla gestione dei moduli
// ora mi tocca creare un duplicato in module.service.ts
export enum NemoModuleKeys {
	AUTHORITY = 'authority',
	CLAIMS = 'claims',
	CONTRACT_CLOSING = 'contract_closing',
	CONTRACT_CLOSING_ = 'contract-closing',
	TYRES = 'tyres',
	USER_CHNAGE = 'user_change',
	USER_CHNAGE_ = 'change-user',
	LOGISTICS = 'logistics',
	FLOTTA_POOL = 'flotta-pool',
	INVOICING = 'invoicing',
	DELIVERY = 'delivery',
	BOOKINGS = 'bookings',
	BOOKINGS_RELIEF = 'bookings-relief',
	BOOKINGS_PRELEASE = 'bookings-prelease',
	NOTIFICATION_CENTER = 'notification-center',
	MOBILITY = 'mobility',
	ADMINISTRATION = 'administration',//Rimane per comodità ma è stato splittato nei successivi tre valori
	ADMINISTRATION_USER_MANAGEMENT = 'administration_user_management',
	ADMINISTRATION_RULES = 'administration_rules',
	ADMINISTRATION_CHANNELING = 'administration_channeling',
	CARGOS = 'cargos'

	// TODO add all the other modules keys
}

export enum EProfileType {
	ADMIN							= 'ADMIN',
	DEALER						= 'DEALER',
	CENTER						= 'CENTER',
	CENTER_SUPER_USER	= 'CENTER_SUPER_USER',
}
